export default __webpack_public_path__ + "static/found-logo-05a5bd3b2c3f892311d3f976732cb0fd.png";